import { Component, input } from '@angular/core';
import { SummaryItem } from '../../../models';
import { ReportValuePairsComponent } from '../report-value-pairs/report-value-pairs.component';

@Component({
  selector: 'app-report-footer-columns',
  templateUrl: './report-footer-columns.component.html',
  styleUrl: './report-footer-columns.component.scss',
  imports: [ReportValuePairsComponent],
})
export class ReportFooterColumnsComponent {
  public readonly summaryItems = input<SummaryItem[][]>();
}
